import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors, space, mediaQueries } from 'style/config';
import anaUtils from 'analytics/utils';
import Chiclet from 'components/Chiclet';
import Action from 'components/Content/Action';
import ShopMyStoreChiclet from 'components/ShopYourStore/ShopMyStoreChiclet';
import localeUtils from 'utils/LanguageLocale';

const ActionChiclet = Action(Chiclet);

function ChicletNav({ menuItems }) {
    const Component = ActionChiclet;

    return menuItems ? (
        <div
            css={styles.chicletWrap}
            data-at={Sephora.debug.dataAt('category_chiclets')}
        >
            <ShopMyStoreChiclet />
            {menuItems.map((item, index) => {
                const componentSpecificProps = { action: item.link, children: item.label, dontUseInternalTracking: true };
                const url = item.link?.targetUrl || item.link?.urlParameters || item.link?.page?.slug;
                const showGiftsIcon =
                    (url?.includes('/shop/gifts') || url?.includes('/beauty/giftcards') || url === 'gifts' || url === 'giftcards') &&
                    !localeUtils.isFrench();

                return (item.titleText && item.targetUrl) || (item.label && item.link) ? (
                    <Component
                        key={index.toString()}
                        variant='shadow'
                        {...componentSpecificProps}
                        onClick={() => {
                            anaUtils.setNextPageData({
                                navigationInfo: anaUtils.buildNavPath(['top nav', componentSpecificProps.children.toLowerCase()]),
                                internalCampaign: item.sid
                            });
                        }}
                        children={componentSpecificProps.children}
                        customCSS={styles.customCSS}
                        css={showGiftsIcon && styles.holidayTreatment}
                    />
                ) : null;
            })}
        </div>
    ) : null;
}

const styles = {
    chicletWrap: {
        display: 'flex',
        gap: space[2],
        fontSize: 0,
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        padding: space[2],
        textAlign: 'center',
        scrollbarWidth: 'none',
        borderBottom: `1px solid ${colors.lightGray}`,
        '&::-webkit-scrollbar': { display: 'none' },
        [mediaQueries.md]: {
            display: 'none'
        }
    },
    customCSS: {
        flex: '0 0 auto'
    },
    holidayTreatment: {
        backgroundImage: 'url(/img/ufe/holiday/2025-holiday-mobile.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minWidth: '120px',
        justifyContent: 'center'
    }
};

export default wrapFunctionalComponent(ChicletNav, 'ChicletNav');
